(() => {
    const lists = document.querySelectorAll(".x-faq-list");
    if (!lists.length) return;

    const closeItem = (item) => {
        item.classList.remove("is-open");
        const q = item.querySelector(".question");
        const a = item.querySelector(".answer");
        const i = item.querySelector(".icon");
        if (q) q.setAttribute("aria-expanded", "false");
        if (a) a.hidden = true;
        if (i) {
            i.classList.remove("icon-arrow-up");
            i.classList.add("icon-arrow-down");
        }
    };

    const openItem = (item) => {
        item.classList.add("is-open");
        const q = item.querySelector(".question");
        const a = item.querySelector(".answer");
        const i = item.querySelector(".icon");
        if (q) q.setAttribute("aria-expanded", "true");
        if (a) a.hidden = false;
        if (i) {
            i.classList.remove("icon-arrow-down");
            i.classList.add("icon-arrow-up");
        }
    };

    lists.forEach((list) => {
        if (list.dataset.faqBound === "1") return;
        list.dataset.faqBound = "1";

        list.querySelectorAll(".faq-item").forEach(closeItem);

        list.addEventListener("click", (e) => {
            const question = e.target.closest(".question");
            if (!question || !list.contains(question)) return;

            e.preventDefault();
            e.stopImmediatePropagation();

            const item = question.closest(".faq-item");
            if (!item) return;

            const isOpen = item.classList.contains("is-open");

            list.querySelectorAll(".faq-item.is-open").forEach((open) => {
                if (open !== item) closeItem(open);
            });

            if (isOpen) closeItem(item);
            else openItem(item);
        });

        list.addEventListener("keydown", (e) => {
            if (e.key !== "Enter" && e.key !== " ") return;
            const question = e.target.closest(".question");
            if (!question || !list.contains(question)) return;
            e.preventDefault();
            question.click();
        });
    });
})();
